import { pickLocale } from './locale'

const en = {
  wishes: {
    kicker: 'Wishes',
    title: 'What you can prepare.',
    more: 'and more...',
    tags: { public: 'Public', private: 'Private' },
    items: [
      { icon: 'body', scope: 'public', title: 'Body', text: 'Organs, burial, science. Your call.' },
      { icon: 'music', scope: 'public', title: 'Music', text: 'The playlist for your last party.' },
      { icon: 'clothes', scope: 'public', title: 'Clothes', text: 'Leave in style, not in that old sweater.' },
      { icon: 'notes', scope: 'public', title: 'Open notes', text: 'A public word for anyone passing by.' },
      { icon: 'video', scope: 'private', title: 'One video', text: 'If you watch this...' },
      { icon: 'letter', scope: 'private', title: 'One letter', text: 'If you read this...' },
      { icon: 'accounts', scope: 'private', title: 'Accounts', text: 'Passwords and hints, released only then.' },
      { icon: 'scheduled', scope: 'private', title: 'Scheduled messages', text: 'A happy birthday, ten years from now.' },
    ],
  },
  tier: {
    cta: 'See plans',
  },
  heartbeat: {
    app: 'Bzioup',
    when: 'now',
    question: 'Still around?',
    answer: 'Yes, still here',
    caption: 'One tap a week. That is the whole job.',
  },
  comingSoon: {
    kicker: 'Next',
    tags: ['Your idea?'],
    contact: 'Tell us',
  },
}

const fr = {
  wishes: {
    kicker: 'Souhaits',
    title: 'Ce que vous pouvez préparer.',
    more: 'et plus encore...',
    tags: { public: 'Public', private: 'Privé' },
    items: [
      { icon: 'body', scope: 'public', title: 'Corps', text: 'Organes, sépulture, science. À vous de voir.' },
      { icon: 'music', scope: 'public', title: 'Musique', text: 'La playlist de votre dernière fête.' },
      { icon: 'clothes', scope: 'public', title: 'Vêtements', text: 'Partir avec style, pas dans ce vieux pull.' },
      { icon: 'notes', scope: 'public', title: 'Notes ouvertes', text: 'Un mot public pour qui passe par là.' },
      { icon: 'video', scope: 'private', title: 'Une vidéo', text: 'Si vous regardez ceci...' },
      { icon: 'letter', scope: 'private', title: 'Une lettre', text: 'Si vous lisez ceci...' },
      { icon: 'accounts', scope: 'private', title: 'Comptes', text: 'Mots de passe et indices, libérés seulement à ce moment-là.' },
      { icon: 'scheduled', scope: 'private', title: 'Messages programmés', text: 'Un joyeux anniversaire, dans dix ans.' },
    ],
  },
  tier: {
    cta: 'Voir les tarifs',
  },
  heartbeat: {
    app: 'Bzioup',
    when: 'maintenant',
    question: 'Toujours là ?',
    answer: 'Oui, toujours là',
    caption: 'Une tape par semaine. C\'est tout le travail.',
  },
  comingSoon: {
    kicker: 'Ensuite',
    tags: ['Votre idée ?'],
    contact: 'Dites-nous',
  },
}

export function getFeaturesContent(language) {
  return pickLocale({ en, fr }, language)
}
